import { usePlantsStore } from '@/services/store/use-plants-store.tsx';
import { User } from 'lucide-react';
import { useShallow } from 'zustand/react/shallow';
import { cn } from '@/utils/utils.ts';

export function PlantMenuPopoverChangeViewButton() {
  const [pageView, setPageView] = usePlantsStore(
    useShallow((state) => [state.pageView, state.setPageView])
  );

  const pageViewButtonLabel = pageView === 'advanced' ? 'Admin view' : 'Guest view';

  return (
    <div>
      <button
        onClick={() => {
          if (!pageView) setPageView('basic');

          if (pageView === 'basic') setPageView('advanced');
          if (pageView === 'advanced') setPageView('basic');
        }}
        className={cn(
          'flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm',
          'text-left',
          'hover:bg-accent hover:text-accent-foreground',
          'focus-visible:bg-accent focus-visible:text-accent-foreground focus-visible:outline-none',
          'disabled:pointer-events-none disabled:opacity-50'
        )}
        role="menuitem"
      >
        <User className="size-4" />
        {pageViewButtonLabel}
      </button>
    </div>
  );
}
